import { toast } from "react-toastify";
import axios from "../services/api/api";
import { API_BASE_URL } from "../constants/api.constants";
import { formatServiceError } from "./serviceErrorHelper";
import { TOAST_CONFIG } from "./toastConfig";

export const linkModulesToCourses = async (
  links,
  intl,
  successKey,
  failureKey,
) => {
  const results = await Promise.allSettled(
    links.map(({ courseId, moduleId }) =>
      axios.post(
        `${API_BASE_URL}/Course/AddExistingModuleToCourse` +
          `?courseId=${courseId}&moduleId=${moduleId}&sortOrder=0`,
        {},
      ),
    ),
  );

  const failed = [];
  results.forEach((result, index) => {
    if (result.status === "rejected") {
      const reason =
        formatServiceError(intl, result.reason?.response?.data) ||
        intl.formatMessage({ id: "GenericApiError" });
      failed.push({ ...links[index], reason });
    }
  });

  if (failed.length > 0) {
    toast.warn(
      <span style={{ whiteSpace: "pre-line" }}>
        {[
          intl.formatMessage({ id: failureKey }),
          ...failed.map((link) => `${link.label}: ${link.reason}`),
        ].join("\n")}
      </span>,
      { ...TOAST_CONFIG, autoClose: 10000 },
    );
  }

  const succeeded = links.length - failed.length;
  if (succeeded > 0) {
    toast.success(
      intl.formatMessage({ id: successKey }, { count: succeeded }),
      TOAST_CONFIG,
    );
  }
};
